





























import { Component, Vue } from 'vue-property-decorator'
import { MutationTypes } from '@/store/mutation-types'

@Component
export default class ErrorDialog extends Vue {
  private copied = false

  private closeModal() {
    this.copied = false
    this.$store.commit(MutationTypes.SET_ERROR_MODAL, {
      show: false,
      title: '',
      message: '',
      color: 'danger',
      copyable: true
    })
  }

  private async copyMessage() {
    const text = this.$store.getters.errorModal.message
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // Fallback for browsers/contexts without the Clipboard API
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
    this.copied = true
  }
}
